<template>
  <div>
    <b-breadcrumb :items="breadcrumbItems"></b-breadcrumb>

    <h4 qid="data-object-page-title" class="mb-1">
      <button class="btn btn-secondary-dark float-right"
              @click="filterOpened = !filterOpened"
              qid="data-object-filter-button"
      >
        <font-awesome-icon icon="filter"/>
      </button>
      <!-- <router-link
          to="/maintenance/data-objects/create"
          class="btn btn-success float-right"
          qid="do-create-button"
          v-if="isGranted(permissions.DATA_OBJECT_CREATE)"
      >
        <font-awesome-icon icon="plus-circle"/> {{ $t('maintenance.data_objects.create_button') }}
      </router-link> -->
      <span v-if="isGranted(permissions.DATA_OBJECT_CREATE)"
            class="btn btn-success float-right"
            qid="do-create-button"
            @click="showCreateDOModal()"
      >
        <font-awesome-icon icon="plus-circle"/> {{ $t('maintenance.data_objects.create_button') }}
      </span>
      <b-form-input
          type="text"
          v-model="filters.keywordValue"
          class="float-right mw-300 mr-3 search-bar"
          v-on:input="debounceInput"
          :placeholder="$t('maintenance.data_objects.search_placeholder')"
          qid="do-search-input"
      ></b-form-input>
      {{ $t('maintenance.data_objects.title') }}
    </h4>
    <div>
      <span v-if="getGuide('data_objects_list')">
        <GuideButton :guide="getGuide('data_objects_list')"></GuideButton>
      </span>
    </div>
    <div class="row mt-4" :class="{'table-with-filters': filterOpened}">
      <div class="col-sm-10 table-container">
        <div class="">
          <table class="table table-responsive-md table-list">
            <thead>
              <tr>
                <th scope="col"
                    class="cursor-pointer"
                    @click="selectSort('name')"
                    qid="do-sort-name"
                >
                  {{ $t('maintenance.data_objects.table.name') }}
                  <span class="ml-2">
                    <font-awesome-icon class="text-muted" icon="sort" v-if="selectedSort !== 'name'"/>
                    <font-awesome-icon icon="caret-down" v-if="selectedDirection === 'desc' && selectedSort === 'name'"/>
                    <font-awesome-icon icon="caret-up" v-if="selectedDirection === 'asc' && selectedSort === 'name'"/>
                  </span>
                </th>
                <th scope="col"
                    class="cursor-pointer"
                    @click="selectSort('classification')"
                    qid="do-sort-classification"
                >
                  {{ $t('maintenance.data_objects.table.classification') }}
                  <span class="ml-2">
                    <font-awesome-icon class="text-muted" icon="sort" v-if="selectedSort !== 'classification'"/>
                    <font-awesome-icon icon="caret-down" v-if="selectedDirection === 'desc' && selectedSort === 'classification'"/>
                    <font-awesome-icon icon="caret-up" v-if="selectedDirection === 'asc' && selectedSort === 'classification'"/>
                  </span>
                </th>
                <th scope="col"
                    class="cursor-pointer"
                    @click="selectSort('business_classification')"
                    qid="do-sort-business-classification"
                >
                  {{ $t('maintenance.data_objects.table.business_classification') }}
                  <span class="ml-2">
                    <font-awesome-icon class="text-muted" icon="sort" v-if="selectedSort !== 'business_classification'"/>
                    <font-awesome-icon icon="caret-down" v-if="selectedDirection === 'desc' && selectedSort === 'business_classification'"/>
                    <font-awesome-icon icon="caret-up" v-if="selectedDirection === 'asc' && selectedSort === 'business_classification'"/>
                  </span>
                </th>
                <th scope="col"
                    class="cursor-pointer"
                    @click="selectSort('category')"
                    qid="do-sort-category"
                >
                  {{ $t('maintenance.data_objects.table.category') }}
                  <span class="ml-2">
                    <font-awesome-icon class="text-muted" icon="sort" v-if="selectedSort !== 'category'"/>
                    <font-awesome-icon icon="caret-down" v-if="selectedDirection === 'desc' && selectedSort === 'category'"/>
                    <font-awesome-icon icon="caret-up" v-if="selectedDirection === 'asc' && selectedSort === 'category'"/>
                  </span>
                </th>
                <th scope="col">
                  {{ $t('maintenance.data_objects.table.tags') }}
                </th>
                <th width="130" class="text-right"></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(object, index) in tableItems" :key="'table-row-' + index" :id="'table-row-' + index">
                <b-popover
                    :target="'table-row-' + index"
                    boundary="viewport"
                    triggers="hover"
                    placement="topleft"
                    :delay="{ show: 500, hide: 0 }"
                >
                  <div v-if="object.description" class="mt-2">
                    <span class="text-bold">
                      {{ $t('maintenance.data_objects.create.description_label') }}:
                    </span>
                    <br>
                    {{ object.description | truncate(200)}}
                    <br>
                  </div>
                </b-popover>

                <td>
                  <router-link
                      :to="{ name: 'maintenance.data_objects.view', params: { slug: object.slug }}"
                      qid="do-view-page-link"
                  >
                    {{object.name}}
                  </router-link>
                </td>
                <td>
                  <span class="badge" qid="do-classification" v-if="object.classification">
                    <font-awesome-icon icon="exclamation-triangle" class="risk-0 mr-2" v-if="object.classification == 'N/A'"/>
                    <font-awesome-icon icon="exclamation-triangle" class="risk-1 mr-2" v-if="object.classification == 'Generic art. 6'"/>
                    <font-awesome-icon icon="exclamation-triangle" class="risk-9 mr-2" v-if="object.classification == 'National identification number art. 87'"/>
                    <font-awesome-icon icon="exclamation-triangle" class="risk-16 mr-2" v-if="object.classification == 'Sensitive art. 9' || object.classification == 'Criminal art. 10'"/>
                    {{ $t('classification.' + $options.filters.slugify(object.classification)) }}
                  </span>
                </td>
                <td>
                  <span class="badge" qid="do-classification" v-if="object.business_classification">
                    <font-awesome-icon icon="exclamation-triangle" class="risk-1 mr-2" v-if="object.business_classification == 'Unclassified'"/>
                    <font-awesome-icon icon="exclamation-triangle" class="risk-9 mr-2" v-if="object.business_classification == 'Confidential'"/>
                    <font-awesome-icon icon="exclamation-triangle" class="risk-16 mr-2" v-if="object.business_classification == 'Top secret' || object.business_classification == 'Secret'"/>
                    {{ $t('classification.' + $options.filters.slugify(object.business_classification)) }}
                  </span>
                </td>
                <td>
                  <span qid="do-category" class="badge" v-if="object.category">
                    <font-awesome-icon icon="shapes" class="mr-1"/>
                    {{object.category}}
                  </span>
                </td>
                <td>
                  <span v-for="tag in getReducedTags(object.tags_translated)" qid="p-tags-list">
                    <span class="badge" :title="tag.name_translated">
                      <font-awesome-icon icon="tag"/>
                      {{ tag.name_translated | truncate(35) }}
                    </span>
                  </span>
                  <span v-if="object.tags_translated.length > 3"
                          class="badge cursor-pointer"
                          @click="openTagsModal(object)"
                  >
                    <font-awesome-icon icon="tags"/>
                    + {{ object.tags_translated.length - 3 }}
                  </span>
                </td>
                <td align="right">
                  <span v-if="isGranted([permissions.DATA_OBJECT_EDIT, permissions.DATA_OBJECT_EDIT_OWN], object.created_by) && (!getClient.parent || (getClient.parent && object.partition))"
                        class="btn btn-edit"
                        qid="do-edit-button"
                        @click="showEditDOModal(object)"
                  >
                    <font-awesome-icon icon="pen"/>
                  </span>
                  <span v-if="isGranted([permissions.DATA_OBJECT_DELETE, permissions.DATA_OBJECT_DELETE_OWN], object.created_by) && (!getClient.parent || (getClient.parent && object.partition))"
                        class="btn btn-delete"
                        qid="do-delete-button"
                        @click="showConfirmDeleteModal(object)"
                  >
                    <font-awesome-icon icon="trash-alt"/>
                  </span>
                </td>
              </tr>
              <tr v-if="!loading && !tableItems.length" qid="no-results-row" class="text-center">
                <td colspan="10">
                  <h5 class="mt-3">
                    {{ $t('system.no_results') }}
                  </h5>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="mt-3 pagination row">
          <div class="col-md-6">
            <div class="row">
              <div class="float-left">
                <span class="text-muted pagination-counter">
                  {{ $t('pagination.entries_per_page') }}:
                </span>
              </div>
              <div class="float-left">
                <multiselect
                    v-model="perPage"
                    :options="perPageOptions"
                    track-by="value"
                    label="value"
                    :select-label="$t('system.dropdown_select_label')"
                    :selected-label="$t('system.dropdown_selected_label')"
                    :deselect-label="$t('system.dropdown_deselect_label')"
                    qid="create-org-form-organization-level"
                    @select="perPageChanged"
                    :placeholder="selectedPerPage"
                    @remove="perPageRemoved"
                ></multiselect>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <b-pagination
                class="float-right"
                v-model="currentPage"
                :total-rows="rows"
                :per-page="selectedPerPage"
                aria-controls="my-table"
                @change="pageChanged"
                limit="1"
            >
              <span class="text-muted" slot="first-text"><font-awesome-icon icon="angle-double-left"/></span>
              <span class="text-muted" slot="prev-text"><font-awesome-icon icon="angle-left"/></span>
              <span class="text-muted" slot="next-text"><font-awesome-icon icon="angle-right"/></span>
              <span class="text-muted" slot="last-text"><font-awesome-icon icon="angle-double-right"/></span>
              <div slot="ellipsis-text">
                <b-spinner small type="grow"></b-spinner>
                <b-spinner small type="grow"></b-spinner>
                <b-spinner small type="grow"></b-spinner>
              </div>
              <span class="text-muted" slot="page" slot-scope="{ page, active }">
                <span v-if="active">{{getPerPage}}</span>
              </span>
            </b-pagination>
          </div>
        </div>
      </div>
      <div class="col-sm-2 filter-container">
        <div class="card">
          <div class="card-body">
            <b-form-group>
              <label qid="filter-do-classification-label">
                {{ $t('maintenance.data_objects.create.classification_label') }}
              </label>
              <multiselect
                  v-model="filters.classification"
                  :options="classificationItems"
                  select-label="✔"
                  selected-label="✔"
                  deselect-label="x"
                  :placeholder="$t('maintenance.data_objects.create.classification_placeholder')"
                  label="name"
                  @select="debounceInput"
                  @remove="debounceInput"
                  qid="filter-do-form-classification"
              ></multiselect>
            </b-form-group>

            <b-form-group>
              <label qid="filter-do-classification-label">
                {{ $t('maintenance.data_objects.create.business_classification_label') }}
              </label>
              <multiselect
                  v-model="filters.business_classification"
                  :options="businessClassificationItems"
                  select-label="✔"
                  selected-label="✔"
                  deselect-label="x"
                  :placeholder="$t('maintenance.data_objects.create.business_classification_placeholder')"
                  label="name"
                  @select="debounceInput"
                  @remove="debounceInput"
                  qid="filter-do-form-classification"
              ></multiselect>
            </b-form-group>

            <b-form-group>
              <label qid="filter-do-category-label">
                {{ $t('maintenance.data_objects.create.category_label') }}
              </label>
              <multiselect
                  v-model="filters.category"
                  :options="categoryItems"
                  :placeholder="$t('maintenance.data_objects.create.category_placeholder')"
                  label="category"
                  @select="debounceInput"
                  @remove="debounceInput"
                  select-label="✔"
                  selected-label="✔"
                  deselect-label="x"
                  qid="filter-do-form-category"
              ></multiselect>
            </b-form-group>

            <b-form-group>
              <label qid="filter-do-tags-label">
                {{ $t('systems.create.tags_label') }}
              </label>
              <multiselect
                  v-model="filters.tags"
                  @select="debounceInput"
                  @remove="debounceInput"
                  :options="tags"
                  :multiple="true"
                  select-label="✔"
                  selected-label="✔"
                  deselect-label="x"
                  :taggable="true"
                  track-by="name_translated"
                  :placeholder="$t('systems.create.tags_placeholder')"
                  label="name_translated"
                  qid="filter-do-form-tags"
                  @search-change="loadTags"
                  @tag="addTag"
              ></multiselect>
            </b-form-group>
            <a href="#" @click="resetFilters" class="text-right" qid="do-filters-reset">
              {{ $t('system.reset_filters') }}
            </a>
          </div>
        </div>
      </div>
    </div>

    <!-- Delete data category confirm modal template -->
    <b-modal ref="delete-data-object" modal-class="task-modal">
      <template #modal-header="{ close }">
        <div class="" style="width: 100%;">
          <span @click="hideConfirmDeleteModal" class="btn btn-secondary cursor-pointer float-right ml-2 mr-0">
            <font-awesome-icon icon="times"/>
          </span>
          <h5 class="mb-1 text-center" qid="delete-do-title">
            {{ $t('maintenance.data_objects.delete.title') }}
          </h5>
        </div>
      </template>
      <div class="mb-2 mt-3" style="font-size:18px;">
        <div>
          {{ $t('maintenance.data_objects.delete.description') }}
          <span class="text-bold">
            {{ itemToDelete.name }}
          </span>
        </div>
        <div class="mt-2">
          {{ $t('maintenance.data_objects.delete.are_you_sure') }}
        </div>
      </div>

      <template #modal-footer="{ close }">
        <div class="" style="width: 100%;">
          <div class="alert alert-menu-color color-secondary mb-0" role="alert">
            <div class="row">
              <div class="col-sm-6">

              </div>
              <div class="col-sm-6">
                <div class="text-right">
                  <b-button class=""
                            variant="secondary"
                            @click="hideConfirmDeleteModal"
                            qid="delete-do-cancel-button"
                  >
                    {{ $t('maintenance.data_objects.delete.cancel') }}
                  </b-button>
                  <b-button @click="confirmDeleteDO(itemToDelete)"
                            class="ml-3"
                            variant="danger"
                            qid="delete-do-submit-button"
                            v-if="isGranted([permissions.DATA_OBJECT_DELETE, permissions.DATA_OBJECT_DELETE_OWN], itemToDelete.created_by) && (!getClient.parent || (getClient.parent && itemToDelete.partition))"
                  >
                    {{ $t('maintenance.data_objects.delete.submit') }}
                  </b-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </b-modal>


    <!-- Edit data categories modal template -->
    <b-modal ref="edit-data-object" @hide="hideEditDOModal" modal-class="task-modal" hide-footer>
      <template #modal-header="{ close }">
        <div class="" style="width: 100%;">
          <span @click="hideEditDOModal" class="btn btn-secondary cursor-pointer float-right ml-2 mr-0">
            <font-awesome-icon icon="times"/>
          </span>
          <h5 class="mb-1 text-center" qid="update-do-title">
            {{ $t('maintenance.data_objects.update.title') }}
          </h5>
        </div>
      </template>

      <b-alert v-if="error.length"
               show
               variant="danger"
               qid="edit-do-error"
      >
        {{ error }}
      </b-alert>

      <b-form @submit="editDOFormSubmit" qid="edit-do-form">
        <div class="form-container">
          <b-form-group>
            <label qid="edit-do-name-label">
              {{ $t('maintenance.data_objects.create.name_label') }}<span class="mandatory"> *</span>
            </label>
            <b-form-input
              qid="edit-do-form-name"
              type="text"
              v-model="doForm.name"
              :maxLength="255"
              required
              :placeholder="$t('maintenance.data_objects.create.name_placeholder')"
            ></b-form-input>
          </b-form-group>
          <b-form-group>
            <label qid="edit-do-description-label">
              {{ $t('maintenance.data_objects.create.description_label') }}
            </label>
            <b-form-textarea
              qid="edit-do-form-description"
              v-model="doForm.description"
              rows="6"
              max-rows="6"
              :placeholder="$t('maintenance.data_objects.create.description_placeholder')"
            ></b-form-textarea>
          </b-form-group>
          <b-form-group>
            <label qid="edit-do-classification-label">
              {{ $t('maintenance.data_objects.create.classification_label') }}<span class="mandatory"> *</span>
            </label>
            <multiselect
                v-model="doForm.classification"
                :options="classificationItems"
                :placeholder="$t('maintenance.data_objects.create.classification_placeholder')"
                label="name"
                required
                :select-label="$t('system.dropdown_select_label')"
                :selected-label="$t('system.dropdown_selected_label')"
                :deselect-label="$t('system.dropdown_deselect_label')"
                qid="edit-do-form-classification"
            ></multiselect>
          </b-form-group>
          <b-form-group>
            <label qid="edit-do-business-classification-label">
              {{ $t('maintenance.data_objects.create.business_classification_label') }}
            </label>
            <multiselect
                v-model="doForm.business_classification"
                :options="businessClassificationItems"
                :placeholder="$t('maintenance.data_objects.create.business_classification_placeholder')"
                label="name"
                :select-label="$t('system.dropdown_select_label')"
                :selected-label="$t('system.dropdown_selected_label')"
                :deselect-label="$t('system.dropdown_deselect_label')"
                qid="edit-do-form-business-classification"
            ></multiselect>
          </b-form-group>
          <b-form-group :class="{'multiselect--show-input': categoryInput.length}">
            <label qid="edit-do-category-label">
              {{ $t('maintenance.data_objects.create.category_label') }}
            </label>
            <multiselect
                v-model="selectedCategory"
                :options="categoryItems"
                :placeholder="$t('maintenance.data_objects.create.category_placeholder')"
                :preserveSearch="true"
                @search-change="handleCategoryInput"
                label="category"
                track-by="category"
                :select-label="$t('system.dropdown_select_label')"
                :selected-label="$t('system.dropdown_selected_label')"
                :deselect-label="$t('system.dropdown_deselect_label')"
                qid="edit-do-form-category"
            >
              <template slot="noResult" slot-scope="props">
                {{ $t('maintenance.data_objects.create.category_no_results') }}
              </template>
            </multiselect>
          </b-form-group>
          <b-form-group>
            <label qid="edit-do-tags-label">
              {{ $t('maintenance.data_objects.create.tags_label') }}
            </label>
            <multiselect
                v-model="selectedTags"
                :options="tags"
                :multiple="true"
                :taggable="true"
                track-by="name_translated"
                :select-label="$t('system.dropdown_select_label')"
                :selected-label="$t('system.dropdown_selected_label')"
                :deselect-label="$t('system.dropdown_deselect_label')"
                :placeholder="$t('maintenance.data_objects.create.tags_placeholder')"
                label="name_translated"
                qid="edit-do-tags-select"
                @search-change="loadTags"
                @tag="addTag"
            ></multiselect>
          </b-form-group>
        </div>
        <div class="proxy-footer">
          <div class="alert alert-menu-color color-secondary mb-0" role="alert">
            <div class="row">
              <div class="col-sm-6">

              </div>
              <div class="col-sm-6">
                <div class="text-right">
                  <b-button class=""
                            variant="secondary"
                            @click="hideEditDOModal"
                            qid="edit-do-cancel-button"
                  >
                    {{ $t('maintenance.data_objects.create.cancel') }}
                  </b-button>
                  <b-button type="submit"
                            class="ml-3"
                            variant="success"
                            :disabled="buttonDisabled"
                            qid="edit-do-submit-button"
                  >
                    <span v-if="buttonDisabled" class="mr-1">
                      <font-awesome-icon icon="spinner" size="sm" class="fa-spin"/>
                    </span>
                    {{ $t('maintenance.data_objects.create.submit') }}
                  </b-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </b-form>
    </b-modal>


    <!-- Create data category -->
    <b-modal ref="create-data-object" @hide="hideCreateDOModal" modal-class="task-modal" hide-footer>
      <template #modal-header="{ close }">
        <div class="" style="width: 100%;">
          <span @click="hideCreateDOModal" class="btn btn-secondary cursor-pointer float-right ml-2 mr-0">
            <font-awesome-icon icon="times"/>
          </span>
          <h5 class="mb-1 text-center" qid="create-do-title">
            {{ $t('maintenance.data_objects.create.title') }}
          </h5>
        </div>
      </template>

      <b-alert v-if="error.length"
               show
               variant="danger"
               qid="create-do-error"
      >
        {{ error }}
      </b-alert>

      <b-form @submit="createDOFormSubmit" qid="create-do-form">
        <div class="form-container">
          <b-form-group>
            <label qid="create-do-name-label">
              {{ $t('maintenance.data_objects.create.name_label') }}<span class="mandatory"> *</span>
            </label>
            <b-form-input
              qid="create-do-form-name"
              type="text"
              v-model="doForm.name"
              :maxLength="255"
              required
              :placeholder="$t('maintenance.data_objects.create.name_placeholder')"
            ></b-form-input>
          </b-form-group>

          <b-form-group>
          <label qid="create-do-description-label">
            {{ $t('maintenance.data_objects.create.description_label') }}
          </label>
          <b-form-textarea
            qid="create-do-form-description"
            v-model="doForm.description"
            rows="6"
            max-rows="6"
            :placeholder="$t('maintenance.data_objects.create.description_placeholder')"
          ></b-form-textarea>
          </b-form-group>

          <b-form-group>
          <label qid="create-do-classification-label">
            {{ $t('maintenance.data_objects.create.classification_label') }}<span class="mandatory"> *</span>
          </label>
          <multiselect
              v-model="doForm.classification"
              :options="classificationItems"
              required
              :placeholder="$t('maintenance.data_objects.create.classification_placeholder')"
              label="name"
              :select-label="$t('system.dropdown_select_label')"
              :selected-label="$t('system.dropdown_selected_label')"
              :deselect-label="$t('system.dropdown_deselect_label')"
              qid="create-do-form-classification"
          ></multiselect>
          </b-form-group>
          <b-form-group>
          <label qid="create-do-business-classification-label">
            {{ $t('maintenance.data_objects.create.business_classification_label') }}
          </label>
          <multiselect
              v-model="doForm.business_classification"
              :options="businessClassificationItems"
              :placeholder="$t('maintenance.data_objects.create.business_classification_placeholder')"
              label="name"
              :select-label="$t('system.dropdown_select_label')"
              :selected-label="$t('system.dropdown_selected_label')"
              :deselect-label="$t('system.dropdown_deselect_label')"
              qid="create-do-form-business-classification"
          ></multiselect>
          </b-form-group>
          <b-form-group :class="{'multiselect--show-input': categoryInput.length}">
          <label qid="create-do-category-label">
            {{ $t('maintenance.data_objects.create.category_label') }}
          </label>
          <multiselect
              v-model="selectedCategory"
              :options="categoryItems"
              :placeholder="$t('maintenance.data_objects.create.category_placeholder')"
              :preserveSearch="true"
              @search-change="handleCategoryInput"
              label="category"
              track-by="category"
              :select-label="$t('system.dropdown_select_label')"
              :selected-label="$t('system.dropdown_selected_label')"
              :deselect-label="$t('system.dropdown_deselect_label')"
              qid="create-do-form-category"
          >
            <template slot="noResult" slot-scope="props">
              {{ $t('maintenance.data_objects.create.category_no_results') }}
            </template>
          </multiselect>
          </b-form-group>
          <b-form-group>
          <label qid="create-do-tags-label">
            {{ $t('maintenance.data_objects.create.tags_label') }}
          </label>
          <multiselect
              v-model="selectedTags"
              :options="tags"
              :multiple="true"
              :taggable="true"
              track-by="name_translated"
              :select-label="$t('system.dropdown_select_label')"
              :selected-label="$t('system.dropdown_selected_label')"
              :deselect-label="$t('system.dropdown_deselect_label')"
              :placeholder="$t('maintenance.data_objects.create.tags_placeholder')"
              label="name_translated"
              qid="create-do-tags-select"
              @search-change="loadTags"
              @tag="addTag"
          ></multiselect>
          </b-form-group>
        </div>
        <div class="proxy-footer">
          <div class="alert alert-menu-color color-secondary mb-0" role="alert">
            <div class="row">
              <div class="col-sm-6">

              </div>
              <div class="col-sm-6">
                <div class="text-right">
                  <b-button class=""
                            variant="secondary"
                            @click="hideCreateDOModal"
                            qid="create-mc-cancel-button"
                  >
                    {{ $t('maintenance.data_objects.create.cancel') }}
                  </b-button>
                  <b-button type="submit"
                            class="ml-3"
                            variant="success"
                            :disabled="buttonDisabled"
                            qid="create-do-submit-button"
                  >
                    <span v-if="buttonDisabled" class="mr-1">
                      <font-awesome-icon icon="spinner" size="sm" class="fa-spin"/>
                    </span>
                    {{ $t('maintenance.data_objects.create.submit') }}
                  </b-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </b-form>
    </b-modal>


    <ShowMoreModal
        :items="selectedItem.tags_translated"
        :show="showTagsModal"
        @closeViewModal="closeTagsModal"
        type="tags"
    ></ShowMoreModal>

  </div>
</template>

<script>
  import piincHttp from '@/util/configureAxios.js';
  import ShowMoreModal from '@/components/ShowMoreModal.vue';
  import GuideButton from '@/components/guide/GuideButton.vue';


  export default {
    name: 'DataObject',
    data: function() {
      return {
        breadcrumbItems: [
          {
            text: this.$t('dashboard.title'),
            to: '/'
          },
          {
            text: this.$t('maintenance.title'),
            to: '/maintenance'
          },
          {
            text: this.$t('maintenance.data_objects.title'),
            active: true
          }
        ],
        tableItems: [],

        // Pagination
        perPageOptions: [
          { name: '10', value: '10' },
          { name: '20', value: '20' },
          { name: '50', value: '50' },
          { name: '100', value: '100' }
        ],
        perPage: '',
        selectedPerPage: "10",
        currentPage: 1,
        totalRows: 0,

        itemToDelete: {},
        doForm: {
          name: '',
          description: '',
          classification: '',
          business_classification: '',
          category: [],
          tags: [],
          client:'',
        },
        error: '',
        selectedSort: '',
        selectedDirection: '',
        selectedTags: [],
        selectedCategory: [],
        classificationItems: [
          { name: this.$t('classification.generic_art._6'), value: 'Generic art. 6' },
          { name: this.$t('classification.sensitive_art._9'), value: 'Sensitive art. 9' },
          { name: this.$t('classification.criminal_art._10'), value: 'Criminal art. 10' },
          { name: this.$t('classification.national_identification_number_art._87'), value: 'National identification number art. 87' },
          { name: this.$t('system.n_a'), value: 'N/A' }
        ],
        businessClassificationItems: [
          { name: this.$t('classification.unclassified'), value: 'Unclassified' },
          { name: this.$t('classification.confidential'), value: 'Confidential' },
          { name: this.$t('classification.secret'), value: 'Secret' },
          { name: this.$t('classification.top_secret'), value: 'Top secret' }
        ],
        categoryItems: [],
        categoryInput: '',
        tags: [],
        filterOpened: false,
        keywordValue: '',
        filters: {
          classification: '',
          business_classification: '',
          category: '',
          keywordValue: ''
        },
        loading: true,
        newTags: [],
        buttonDisabled: false,
        selectedItem: {},
        showTagsModal: false,
        myGuides: [],
      }
    },
    components: {
      ShowMoreModal,
      GuideButton
    },
    computed: {
      rows() {
        // Use computed value for rows because of dynamic update
        return this.totalRows
      },
      getClient() {
        return this.$store.state.client
      },
      getFilters() {
        return this.$store.state.activeFilters
      },
      getStorePerPage() {
        return this.$store.state.perPage
      },
      getPerPage() {
        let page = this.currentPage;
        let selectedFrom = (page-1) * Number(this.selectedPerPage) + 1;
        let selectedTo = (page-1) * Number(this.selectedPerPage) + Number(this.selectedPerPage);
        let selectedOf = this.totalRows;

        if(selectedTo > selectedOf){
          selectedTo = selectedOf
        }

        return selectedFrom + " - " + selectedTo + " " + this.$t('system.of') + " " + selectedOf
      }
    },
    watch: {
      // Watch when client changes in store and trigger api reload
      getClient: function () {
        this.loadContent();
        this.loadCategories();
        this.loadTags();
      }
    },
    methods: {
      debounceInput: _.debounce(function() {
        this.loadContent()
      }, 400),
      getGuide(code) {
        let existingGuide = _.find(this.myGuides, function(object) {
          return object.scope == code && object.type == 'Maintenance' && object.enabled
        });
        return existingGuide
      },
      loadGuides(code) {
        let self = this;
        let language = localStorage.getItem('lang')? localStorage.getItem('lang') : 'en';

        piincHttp.get('guides', { params:
          {
            per_page: 1,
            language: 'en',
            type: 'Maintenance',
            scope: code,
            client: this.getClient.slug
          }
        }).then(function(response) {
          if (response.data.items.length) {
            self.myGuides.push(response.data.items[0])
          }
        }, function() {});
      },
      openTagsModal(object) {
        this.selectedItem = object
        this.showTagsModal = true
      },
      closeTagsModal() {
        this.selectedItem = {}
        this.showTagsModal = false
      },
      getReducedTags(tags) {
        let reducedTags = []
        if (tags.length > 3) {
          reducedTags = _.cloneDeep(tags);
          reducedTags = reducedTags.slice(0, 3);
        } else {
          reducedTags = tags;
        }
        return reducedTags;
      },
      resetFilters() {
        this.filters.tags = [];
        this.filters.type = '';
        this.filters.classification = '';
        this.filters.business_classification = '';
        this.filters.category = '';
        this.debounceInput();
      },
      addTag(newTag) {
        const tag = {
          name: newTag,
          translatable: newTag,
          name_translated: newTag
        }
        this.selectedTags.push(tag)
        this.newTags.push(tag)
      },
      handleCategoryInput(input) {
        this.categoryInput = input;
      },
      selectSort(sort) {
        // If old and new sort are same, switch just direction
        if (sort === this.selectedSort) {
          this.selectedDirection = this.selectedDirection === 'desc' ? 'asc' : 'desc';
        } else {
          // If different sort, set sort and set direction to default
          this.selectedDirection = 'desc'
          this.selectedSort = sort;
        }
        this.loadContent();
      },
      loadContent(page, perPage) {

        if (this.getStorePerPage) {
          this.selectedPerPage = this.getStorePerPage;
        }

        // If page is not defined, set page to default 1
        let pageNumber = page ? page : 1;
        let perPageNumber = perPage ? perPage : this.selectedPerPage;
        let self = this;
        let formTags = [];

        if (
          this.filters.keywordValue !== '' ||
          (this.filters.classification && this.filters.classification.value) ||
          (this.filters.business_classification && this.filters.business_classification.value) ||
          (this.filters.category && this.filters.category.category)
        ) {
          this.filtersOpened = true
        }

        if (this.filters.tags && this.filters.tags.length) {
          for (var j = 0; j < this.filters.tags.length; j++) {
            formTags[j] = this.filters.tags[j].id;
          }
          this.filtersOpened = true
        }

        piincHttp.get('data-objects', { params:
          {
            page: pageNumber,
            per_page: perPageNumber,
            sort: this.selectedSort !== '' ? this.selectedSort : undefined,
            order: this.selectedDirection !== '' ? this.selectedDirection : undefined,
            keyword: this.filters.keywordValue !== '' ? this.filters.keywordValue : undefined,
            tags: formTags ? formTags : undefined,
            classification: this.filters.classification ? this.filters.classification.value : undefined,
            business_classification: this.filters.business_classification ? this.filters.business_classification.value : undefined,
            category: this.filters.category ? this.filters.category.category : undefined,
            client: this.getClient.slug
          }
        }).then(function(response) {
          self.loading = false;
          self.tableItems = response.data.items;
          // Set number of total items
          self.totalRows = response.data.total_count;
        }, function() {});
      },
      pageChanged(page) {
        this.loadContent(page)
      },
      perPageChanged(perPage) {
        let self = this;
        // Load content when page changed listener is triggered
        this.loadContent(1, perPage.value)
        self.selectedPerPage = perPage.value
        this.$store.commit('storePerPage', this.selectedPerPage);
      },
      perPageRemoved() {
        let self = this;
        // Load content when page changed listener is triggered
        self.selectedPerPage = self.perPageOptions[0].value
        this.loadContent(1, self.selectedPerPage)
      },
      showConfirmDeleteModal(object) {
        this.itemToDelete = object
        this.$refs['delete-data-object'].show()
      },
      hideConfirmDeleteModal() {
        this.itemToDelete = {}
        this.$refs['delete-data-object'].hide()
      },
      showCreateDOModal() {
        this.doForm.name = ''
        this.doForm.description = ''
        this.doForm.classification = ''
        this.doForm.business_classification = ''
        this.selectedCategory = []
        this.selectedTags = []
        this.loadCategories();
        this.error = ''
        this.$refs['create-data-object'].show()
      },
      showEditDOModal(object) {
        this.error = '';
        let self = this;
        this.loadCategories();
        this.loadTags();

        // Preselect classification on edit modal
        if (object.classification) {
          this.doForm.classification = _.find(this.classificationItems, function(item) {
            return item.value === object.classification;
          });
        }

        if (object.business_classification) {
          this.doForm.business_classification = _.find(this.businessClassificationItems, function(item) {
            return item.value === object.business_classification;
          });
        }

        this.selectedCategory = []
        // Preselect category on edit modal
        if (object.category) {
          _.find(this.categoryItems, function(item) {
            if (item.category === object.category) {
              self.selectedCategory = item;
            }
          });
        }

        this.selectedTags = [];
        // Set selected countries on edit modal
        if (object.tags_translated && object.tags_translated.length) {
          // Clone original data to new object
          this.selectedTags = _.cloneDeep(object.tags_translated);
        }

        this.doForm.slug = object.slug;
        this.doForm.name = object.name;
        this.doForm.description = object.description;
        this.$refs['edit-data-object'].show()
      },
      hideCreateDOModal() {
        this.categoryInput = ''
        this.selectedTags = []
        this.newTags = []
        this.$refs['create-data-object'].hide()
      },
      hideEditDOModal() {
        this.categoryInput = ''
        this.selectedTags = []
        this.newTags = []
        this.$refs['edit-data-object'].hide()
      },
      loadCategories(query) {
        let self = this;
        piincHttp.get('/data-objects/categories', { params:
          {
            client: this.getClient.slug,
            keyword: query ? query : undefined
          }
        }).then(function(response) {
          self.categoryItems = response.data
          if (self.categoryItems && !self.categoryItems.length && !query) {
            self.categoryItems.push({category: self.$t('system.no_results'), $isDisabled: true})
          }
        }, function() {});
      },
      loadTags(query) {
        let self = this;
        piincHttp.get('tags', { params:
          {
            client: this.getClient.slug,
            keyword: query ? query : undefined
          }
        }).then(function(response) {
          self.tags = response.data
          if (self.tags && !self.tags.length && !query) {
            self.tags.push({name_translated: self.$t('system.no_results'), $isDisabled: true})
          }
          for (var i = 0; i < self.newTags.length; i++) {
            self.tags.push(self.newTags[i]);
          }
        }, function() {});
      },
      createDOFormSubmit(evt) {
        this.buttonDisabled = true;
        // Keep the reference in a variable
        // to use it inside function called when promise returned
        let self = this;
        evt.preventDefault();
        this.doForm.client = this.getClient.slug;

        if (this.selectedTags && this.selectedTags.length) {
          this.doForm.tags = [];
          for (var i = 0; i < this.selectedTags.length; i++) {
            this.doForm.tags.push(this.selectedTags[i].name_translated);
          }
        } else {
          this.doForm.tags = [];
        }

        if (this.doForm.name && this.doForm.classification) {
          this.doForm.classification = this.doForm.classification ? this.doForm.classification.value : ''
          this.doForm.business_classification = this.doForm.business_classification ? this.doForm.business_classification.value : ''
        }

        if (this.categoryInput && this.categoryInput.length) {
          this.doForm.category = this.categoryInput
        } else {
          if (this.selectedCategory && this.selectedCategory.category) {
            this.doForm.category = this.selectedCategory.category
          } else {
            this.doForm.category = '';
          }
        }

        piincHttp.post('data-objects/', this.doForm).then(function(response) {
          self.hideCreateDOModal();
          self.loadContent(self.currentPage);
          self.loadCategories();
          self.buttonDisabled = false;
          self.$toastr('success', self.$t('maintenance.data_objects.create.success'))
        }, function(error) {
          if (error.status !== 200) {
            self.buttonDisabled = false;
            // Attach error if exists
            self.error = ''
            if (error.data.errors.name || error.data.errors.classification) {
              if (error.data.errors.name) {
                self.error += ' ' + self.$t('maintenance.data_objects.create.name_error')
              }
              if (error.data.errors.classification) {
                self.error += ' ' + self.$t('maintenance.data_objects.create.classification_error')
              }
            }else{
              self.error = error.data.message;
            }
          }
        })
      },
      editDOFormSubmit(evt) {
        this.buttonDisabled = true;
        // Keep the reference in a variable
        // to use it inside function called when promise returned
        let self = this;
        evt.preventDefault();
        this.doForm.client = this.getClient.slug;

        if (this.selectedTags && this.selectedTags.length) {
          this.doForm.tags = [];
          for (var i = 0; i < this.selectedTags.length; i++) {
            this.doForm.tags.push(this.selectedTags[i].name_translated);
          }
        } else {
          this.doForm.tags = [];
        }

        if (this.doForm.name && this.doForm.classification) {
          this.doForm.classification = this.doForm.classification ? this.doForm.classification.value : ''
          this.doForm.business_classification = this.doForm.business_classification ? this.doForm.business_classification.value : ''
        }

        if (this.categoryInput && this.categoryInput.length) {
          this.doForm.category = this.categoryInput
        } else {
          if (this.selectedCategory && this.selectedCategory.category) {
            this.doForm.category = this.selectedCategory.category
          } else {
            this.doForm.category = '';
          }
        }

        piincHttp.put('data-objects/' + this.doForm.slug, this.doForm).then(function(response) {
          self.hideEditDOModal();
          self.loadContent(self.currentPage);
          self.loadCategories();
          self.buttonDisabled = false;
          self.$toastr('success', self.$t('maintenance.data_objects.update.success'))
        }, function(error) {
          if (error.status !== 200) {
            self.buttonDisabled = false;
            // Attach error if exists
            self.error = ''
            if (error.data.errors.name || error.data.errors.classification) {
              if (error.data.errors.name) {
                self.error += ' ' + self.$t('maintenance.data_objects.create.name_error')
              }
              if (error.data.errors.classification) {
                self.error += ' ' + self.$t('maintenance.data_objects.create.classification_error')
              }
            }else{
              self.error = error.data.message;
            }
          }
        })
      },
      confirmDeleteDO(object) {
        let self = this;
        piincHttp.delete('data-objects/' + object.slug).then(function(response) {
          self.hideConfirmDeleteModal();
          self.loadContent(self.currentPage);
          // Trigger toastr message after modal close
          self.$toastr('success', self.$t('maintenance.data_objects.delete.success'))
        }, function() {});
      }
    },
    beforeRouteLeave(to, from, next) {
      let object = {
        type: 'data_objects',
        filters: this.filters
      }
      this.$store.commit('storeActiveFilters', object);
      this.$store.commit('storePerPage', this.selectedPerPage);
      next()
    },
    created () {
      if (this.getClient && this.getClient.slug) {
        if (this.getFilters.data_objects) {
          this.filters = this.getFilters.data_objects
        }
        this.loadContent();
        this.loadCategories();
        this.loadTags();
      }
      this.loadGuides('data_objects_list');
    }
  }
</script>
